import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import DropdownMenu, { Option } from '../../../components/Menu/DropdownMenu';
import { Grid } from '../../../components/nucleoIcons';

export interface LimitFilterProps extends WithTranslation {
    changeLimit: (limit: number) => void;
    limit: number;
}

const LimitFilter = (
    {
        t,
        limit,
        changeLimit,
    }: LimitFilterProps
) => {
    const options: Option[] = ['20', '100'].map((value) => ({
        label: value,
        value,
        onClick: (value) => {
            changeLimit(parseInt(value));
        },
    }));

    return (
        <DropdownMenu
            label={<Grid />}
            title={t('payments.transactions.paging_menu_title')}
            value={(limit || 20).toString()}
            options={options}
            initialOpen={false}
        />
    );
};

export default withTranslation()(LimitFilter);
